import { useWorkflowNames } from "../data/workflow";
import { Dropdown } from ".";
import { isEmpty, isArray } from "lodash";
import { useEffect } from "react";

export default function WorkflowNameInput(props) {
  const { data, refetch } = useWorkflowNames();
  const options =  data?isArray(data)?data:[]:[]

  useEffect(() => {
    // Trigger a refetch when workflowName changes
    refetch();
  }, []);  

  return (
    <Dropdown
      label={props.label || "Workflow Name"}
      options={options}
      multiple
      freeSolo
      loading={isEmpty(options)}
      {...props}
    />
  );
}
